/**
 * Processes XML data to extract the root element name and the number of child elements.
 *
 * @param {String} xmlText - The XML data as a string.
 * @return {Object} An object containing the root element name and the number of child elements.
 * @throws {Error} If the XML is invalid.
 */
const processXML = xmlText => {
	const parser = new DOMParser();
	const xmlDoc = parser.parseFromString( xmlText, "application/xml" );

	// Check for parser errors
	if ( xmlDoc.getElementsByTagName( 'parsererror' ).length > 0 ) {
		throw new Error( 'Invalid XML' );
	}

	const rootElement = xmlDoc.documentElement;
	const rootElementName = rootElement.nodeName;
	const numberOfChildElements = rootElement.children.length;

	return {
		type: 'xml',
		rootElementName: rootElementName,
		numberOfChildElements: numberOfChildElements
	};
}

export default processXML;
